export type CookieConsent = {
  necessary: true;
  analytics: boolean;
  marketing: boolean;
  timestamp: string;
};

export type CookieConsentDraft = {
  analytics: boolean;
  marketing: boolean;
};

export function createConsent(
  draft: CookieConsentDraft,
): CookieConsent {
  return {
    necessary: true,
    analytics: draft.analytics,
    marketing: draft.marketing,
    timestamp: new Date().toISOString(),
  };
}

export function acceptAllConsent(): CookieConsent {
  return createConsent({ analytics: true, marketing: true });
}

export function rejectAllConsent(): CookieConsent {
  return createConsent({ analytics: false, marketing: false });
}
